module.exports = __webpack_public_path__ + "static/media/country-2.2b3b344e.jpg";